import React from "react";
import "./Signup.css";
const Signup = () => {
  return (
    <section className="form-section-">
      <div className="container">
        <div className="row">
          <div className="col-12 max-width mx-auto">
            <div className="form-page- max-width1- mx-auto">
              <form action="" id="form-" className="form- w-100">
                <h6 className="form-heading- mb-4">Let's Sign you in</h6>
                <p className="form-paragrapgh- mb-2">
                  Welcome Back,
                  <br />
                  You have been missed
                </p>
                <input
                  type="email"
                  className="form-control mt-3 py-3 px-4 form-input-text-"
                  placeholder="Email, phone & username"
                />
                <input
                  type="password"
                  placeholder="Password"
                  className="form-control mt-3 py-3 px-4 form-input-text-"
                />
                <p className="form-paragraph1- my-4">
                  <a href="/" className="ForgetPassowrd">
                    Forgot Password ?
                  </a>
                </p>
                <a href="/" className="btn form-btn- py-3 px-4">
                  Sign up
                </a>
                <p className="form-paragraph2- my-4">
                  Don't have an account ?
                  <b className="form-register-">
                    <a href="/" className="ForgetPassowrd">
                      Register Now
                    </a>
                  </b>
                </p>
                <a href="/" className="btn form-btn1- mx-auto mt-5">
                  Connect Now
                </a>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Signup;
